module.exports = __webpack_public_path__ + "static/media/Dark brown 106.d7c84cf1.jpg";